

export const sliderData = [
    {
      image: "https://netstorage-legit.akamaized.net/images/f5f601a65f341b59.jpg?imwidth=900",
      heading: "Residency Hotel Ogidi",
      desc: "The Internet of Things Helps Businesses across Industries.",
    },
    {
      image: "https://media-cdn.tripadvisor.com/media/photo-s/06/20/5b/1d/inside.jpg",
      heading: "Residency Hotel Lekki Phase 1",
      desc: "with Cloud solutions from Vitel, communications is as simply as Push-to-Talk mobile and desktop devices.",
    },
    {
      image: "https://media-cdn.tripadvisor.com/media/photo-s/22/00/3b/5d/rio-lounge-interior.jpg",
      heading: "Residency Hotel Ajao",
      desc: "Our radical approach to IoT and VAS integrated solution means that everything we offer are connected",
    },
  ];